/**
 * Toggle Filters - open filter menu
 * Add active class to currently selected radio button
 * Clear filters button
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
 */

const ToggleFilters = () => {
    const toggle = document.getElementById('toggleFilters');
    const filters = document.getElementById('filtersList');
    if (!toggle || !filters) return;

    toggle.addEventListener('click', () => {
        if (!toggle.classList.contains('open')) {
            toggle.classList.add('open');
            filters.classList.add('open');
        } else {
            toggle.classList.remove('open');
            filters.classList.remove('open');
        }
    });

    const radioContainers = [...document.querySelectorAll('.radio-container')];
    radioContainers.forEach(radio => {
        radio.addEventListener('click', () => {
            radioContainers.forEach(others => {
                others.classList.remove('active');
            });
            radio.classList.add('active');
        });
    });
};

export default ToggleFilters;
